@if (imageUrl) {

    <div class="close-button" (click)="closeModal()">
        <span></span>
        <span></span>
    </div>

    <div class="modal" (click)="closeModal()">
        <div class="modal-content">
          <img [src]="imageUrl" [alt]="altText">
        </div>
    </div>
}
